let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lNhhu")).then(() => parcelRequire('lYm65'));